<template>
  <section class="background--views">
    <v-container>
      <audit-logs-table></audit-logs-table>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "AuditLogs",
  components: {
    AuditLogsTable: () => import("../components/audit-logs/AuditLogsTable.vue"),
  },
};
</script>
